import React from 'react';
import styled from 'styled-components';
import WmsWeightListing from './components/WmsWeightListing';

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 50px 0 0 0;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

/**
 * Admin page for filling in the product weight the WMS relies on.
 *
 * Admin-only: the /api/wms/* endpoints sit behind adminAuthMiddleware, so a
 * supplier session would only get 401s here.
 */
const WmsWeightManagement = () => {
	const admin = localStorage.getItem('admin');

	if (!admin) {
		window.location.href = '/not-found';
		return null;
	}

	return (
		<HelpPageWrapper>
			<WmsWeightListing/>
		</HelpPageWrapper>
	);
};

export default WmsWeightManagement;
